const AppConfig = {
  API_URL: process.env.REACT_APP_API_URL,
  STATIC_BASE_URL: process.env.REACT_APP_STATIC_BASE_URL,
  GRECAPTCHA_SITE_KEY: process.env.REACT_APP_GRECAPTCHA_SITE_KEY,
  PW_MIG_URL: process.env.REACT_APP_PW_MIG_URL,
  NEWS_URL: process.env.REACT_APP_NEWS_URL
};

export default AppConfig;
